import { Alert, Button, Chip, CircularProgress, Container } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useCallback, useEffect, useState } from "react";
import { LICENSE_URL } from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import AppTableView from "../AppTableView";
import LicenseDialog from "./LicenseDialog";
import { useAlert } from "../alerts/AlertContext";

const statusColors = {
  open: "#007BFF",
  "in-progress": "#FD7E14",
  hold: "#FFC107",
  resolved: "#20C997",
  closed: "#6C757D",
};

function License() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const showAlert = useAlert();

  const getLicenseData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await AxiosInstance.get(LICENSE_URL);
      setData(response.data || []);
    } catch (error) {
      console.error("Error fetching license data:", error);
      setError("Failed to load license data. Please try again.");
      // showAlert("Failed to load statuses", "error");
    } finally {
      setLoading(false);
    }
  }, [showAlert]);

  useEffect(() => {
    getLicenseData();
  }, [getLicenseData]);

  const columns = [
    {
      field: "productId",
      flex: 1,
      headerName: "Product Id",
      renderCell: (params) => params.value.name,
    },
    {
      field: "email",
      flex: 2,
      headerName: "Email",
      renderCell: (params) => params.value.name,
    },
    {
      field: "startDate",
      flex: 1,
      headerName: "Start Date",
      renderCell: (params) => new Date(params.row?.startDate).toISOString().split("T")[0]
    },    
    {
      field: "endDate",
      flex: 1,
      headerName: "End Date",
       renderCell: (params) => new Date(params.row?.endDate).toISOString().split("T")[0]      
    },
    {
      field: "action",
      flex: 1,
      headerName: "Actions",
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <LicenseDialog
            licenseId={params.row.id}
            licenseName="Edit"
            variant="link"
          />
        </Box>
      ),
    },
  ];

  //if error content
  if (error) {
    return (
      <Container>
        <Alert
          severity="error"
          action={
            <Button color="inherit" size="small" onClick={getLicenseData}>
              Retry
            </Button>
          }
          sx={{ borderRadius: 2 }}
        >
          {error}
        </Alert>
      </Container>
    );
  }

  return (
    <Box
      sx={{
        borderRadius: "8px",
        overflow: "hidden",
        p: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      {/* loading or content */}
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <AppTableView rows={data} cols={columns} initialPageSize={5} />
      )}
    </Box>
  );
}

export default License;
